import axios from "axios";
import { baseUrl, portal } from "../App";
import { EVENT_ID } from "../assets/constant";
import { transformQuizardWinnerLeaderboardDataArray, transformTournamentTopDataArray, transformWeeklyLeaderboardDataArray, transformWinnerlistDataArray } from "./transformDataFormat";

export const fetchLeaderboardByLeaderboarName = async (leaderboardName) => {
  if(!leaderboardName) return [];
  // for daily leaderboard
  if(leaderboardName === 'leaderboard_daily'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${EVENT_ID.DAILY_EVENT}`);
    return res.data;
  }else if(leaderboardName === 'leaderboard_weekly'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${EVENT_ID.WEEKLY_EVENT}`);
    return res.data;
  }else if(leaderboardName === 'leaderboard_tournament'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${EVENT_ID.TOURNAMENT_EVENT}`);
    return res.data;
  }else if(leaderboardName === 'leaderboard_bcs'){
    const res = await axios.get(`${baseUrl}/api/leaderboard/?portal=${portal}&event_id=${EVENT_ID.BCS_EVENT}`);
    return res.data;
  }
  // for current Week Leaderboard
  else if(leaderboardName === 'leaderboard_w_daily'){
    return []
    const res = await axios.get(`${baseUrl}/money/getWeeklyLeaderboardData/`);
    return transformWeeklyLeaderboardDataArray(res.data,EVENT_ID.DAILY_EVENT);
  }
  else if(leaderboardName === 'leaderboard_w_weekly'){
    return []
    const res = await axios.get(`${baseUrl}/money/getWeeklyLeaderboardData/`);
    return transformWeeklyLeaderboardDataArray(res.data,EVENT_ID.WEEKLY_EVENT);
  }
  else if(leaderboardName === 'leaderboard_w_tournament'){
    return []
    const res = await axios.get(`${baseUrl}/money/getWeeklyLeaderboardData/`);
    return transformWeeklyLeaderboardDataArray(res.data,EVENT_ID.TOURNAMENT_EVENT);
  }
  else if(leaderboardName === 'leaderboard_w_bcs'){
    return []
    const res = await axios.get(`${baseUrl}/money/getWeeklyLeaderboardData/`);
    return transformWeeklyLeaderboardDataArray(res.data,EVENT_ID.BCS_EVENT);
  }
  // for last 7 days winner list
  else if(leaderboardName === 'winner_t_daily'){
    return []
    const res = await axios.get(`${baseUrl}/money/topWinnerData/?event_id=${EVENT_ID.DAILY_EVENT}`);
    return transformWinnerlistDataArray(res.data,10);
  }
  else if(leaderboardName === 'winner_weekly'){
    return []
    const res = await axios.get(`${baseUrl}/money/weeklyWinner/?event_id=${EVENT_ID.WEEKLY_EVENT}`);
    return transformWinnerlistDataArray(res.data,10);
  }
  else if(leaderboardName === 'winner_tournament'){
    return []
    const res = await axios.get(`${baseUrl}/money/weeklyWinner/?event_id=${EVENT_ID.TOURNAMENT_EVENT}`);
    return transformWinnerlistDataArray(res.data,10);
  }
  else if(leaderboardName === 'winner_t_tournament'){
    return []
    const res = await axios.get(`${baseUrl}/money/topWinnerData/?event_id=${EVENT_ID.TOURNAMENT_EVENT}`);
    return transformWinnerlistDataArray(res.data,10);
  }
  else if(leaderboardName === 'winner_bcs'){
    return []
    const res = await axios.get(`${baseUrl}/money/weeklyWinner/?event_id=${EVENT_ID.BCS_EVENT}`);
    return transformWinnerlistDataArray(res.data,10);
  }

  // for yesterday winner leaderboard
  // http://cms.quizard.live/money/tWinnerApiFrontendYesterday/?event_id=75
  // http://cms.quizard.live/money/tWinnerApiFrontendYesterday/?quizid=34&numberOfWinner=15 
  else if(leaderboardName === 'winner_y_daily'){
    // https://cms.quizard.live/34
    const res = await getDailyWinnerData('Daily');
    return transformQuizardWinnerLeaderboardDataArray(res,50);
  }
  else if(leaderboardName === 'winner_y_weekly'){
    const res = await getDailyWinnerData('Sports');
    return transformQuizardWinnerLeaderboardDataArray(res,50);
  }
  else if(leaderboardName === 'winner_y_tournament'){
    const res = await getDailyWinnerData('Tournament');
    return transformQuizardWinnerLeaderboardDataArray(res,40);
  }
  else if(leaderboardName === 'winner_y_bcs'){
    const res = await getDailyWinnerData('BCS');
    return transformQuizardWinnerLeaderboardDataArray(res,50);
  }
  else{
    return [];
  }
}



export async function getDailyWinnerData(serviceType, category = null) {
  return []
  const API_URL = `${baseUrl}/money/dailyAllWinnerDataAPIView/`;
  const STORAGE_KEY = "dailyWinnerData";
  const cached = sessionStorage.getItem(STORAGE_KEY);

  if (cached) {
    const parsed = JSON.parse(cached);
    const now = new Date();
    const cacheTime = new Date(parsed.timestamp);
    const isSameDay =
      now.toDateString() === new Date(parsed.date).toDateString();
    const diffMinutes = (now - cacheTime) / 1000 / 60;

    if (isSameDay && diffMinutes < 30) {
      return filterAndSort(parsed.data, serviceType, category);
    }
  }

  // ❌ No valid cache → Fetch new data
  try {
    const response = await axios.get(API_URL);
    const data = response.data;

    if (data?.message === "No records found") {
      return [];
    }

    // Save full data to session storage
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        data,
        timestamp: new Date().toISOString(),
        date: new Date().toISOString(),
      })
    );

    return filterAndSort(data, serviceType, category);
  } catch (error) {
    console.error("Error fetching daily winner data:", error);
    throw error;
  }
}

// 🔹 Helper: filter & sort
function filterAndSort(data, serviceType, category) {
  if (!Array.isArray(data)) {
    return [];
  }
  let filtered = data.filter((item) => item.service_type === serviceType);

  if (category !== null) {
    filtered = filtered.filter((item) => item.category === category);
  }

  return filtered.sort((a, b) => a.serial_no - b.serial_no);
}
